import { TASK_STATUS, WORK_AGE, WORK_CATEGORY } from 'modules/work-implementation/constants';
import { WORK_PROGRESS_STEPS, WORK_PROGRESS_STEP_KEYS } from '../constants';

function slabConfig(v, slabsCount) {
  if (slabsCount === 0) return { range: { start: null, end: null }, count: 0 };
  if (v.workCategory === WORK_CATEGORY.ALLIED || v.workAge === WORK_AGE.NEW)
    return { range: { start: 1, end: slabsCount }, count: slabsCount };

  const primary = v.basementDrawings + v.groundLevelDrawings + v.upperFloorDrawings + 2;
  const newDrawings = Math.max(v.upperFloorDrawings - v.existingFloorDrawings, 0) + 2;

  const start = primary - newDrawings + 1;
  const end = slabsCount;

  return {
    range: { start, end: start === end ? null : end },
    count: end - start + 1,
  };
}

export function deriveTaskConfig(values: Record<string, any> = {}) {
  const columnFootingDrawings = values.columnDrawings;
  const structuralDrawings = values.structuralDrawings;

  const slabsCount = structuralDrawings - columnFootingDrawings;
  const slabsConfig = slabConfig(values, slabsCount);

  return {
    columnFootingDrawings,
    columnRange: {
      start: columnFootingDrawings > 1 ? 1 : null,
      end: columnFootingDrawings > 1 ? columnFootingDrawings : null,
    },
    slabDrawings: slabsConfig.count,
    slabsRange: slabsConfig.range,
    totalDrawings: columnFootingDrawings + slabsConfig.count,
  };
}

export function getWorkProgressSteps(taskList, totalDrawings) {
  const steps = WORK_PROGRESS_STEPS;

  if (!taskList || !Array.isArray(taskList)) return steps;

  const assignStep = steps.find((step) => step.key === WORK_PROGRESS_STEP_KEYS.ASSIGN);
  const inProgressStep = steps.find((step) => step.key === WORK_PROGRESS_STEP_KEYS.IN_PROGRESS);
  const approvalStep = steps.find((step) => step.key === WORK_PROGRESS_STEP_KEYS.APPROVAL);

  const hasAssignedTasks = taskList.some((task) => task.status === TASK_STATUS.ASSIGNED);
  const hasInProgressTasks = taskList.some(
    (task) =>
      task.status === TASK_STATUS.IN_PROGRESS ||
      task.status === TASK_STATUS.SUBMITTED ||
      task.status === TASK_STATUS.REVISION_REQUESTED,
  );
  const hasApprovedTasks = taskList.some((task) => task.status === TASK_STATUS.APPROVED);
  const approvedTasksCount = taskList.filter((task) => task.status === TASK_STATUS.APPROVED).length;

  const updatedAssignStep = {
    ...assignStep,
    disabled: totalDrawings === 0,
    in_progress: hasAssignedTasks,
    completed: taskList.length === totalDrawings,
  };

  const updatedInProgressStep = {
    ...inProgressStep,
    disabled: totalDrawings === 0 || taskList.length === 0 || !hasInProgressTasks,
    in_progress: hasInProgressTasks,
    completed: approvedTasksCount === totalDrawings,
  };

  const updatedApprovalStep = {
    ...approvalStep,
    disabled: totalDrawings === 0 || approvedTasksCount === 0,
    in_progress: hasApprovedTasks,
    completed: approvedTasksCount === totalDrawings,
  };

  return steps.map((step) => {
    if (step.key === WORK_PROGRESS_STEP_KEYS.ASSIGN) {
      return updatedAssignStep;
    }
    if (step.key === WORK_PROGRESS_STEP_KEYS.IN_PROGRESS) {
      return updatedInProgressStep;
    }
    if (step.key === WORK_PROGRESS_STEP_KEYS.APPROVAL) {
      return updatedApprovalStep;
    }
    return step;
  });
}
